import { render, staticRenderFns } from "./2023_1111.vue?vue&type=template&id=3dc22c48&scoped=true&"
import script from "./2023_1111.vue?vue&type=script&lang=js&"
export * from "./2023_1111.vue?vue&type=script&lang=js&"
import style0 from "./2023_1111.vue?vue&type=style&index=0&id=3dc22c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc22c48",
  null
  
)

export default component.exports